<template>
    <interview-action-enter
        componentIs="v-sheet"
        max-width="720"
        v-bind="{
            code,
            onError,
        }"
        v-slot="{ enter, loading, errorMessages }"
    >
        <p class="font-size-14 grey--text text--lighten-2" v-if="mode == 'view'">
            마이스팩의 비대면 면접 솔루션입니다. <br />
            참여코드를 입력 후 면접에 참여하거나 알림톡의 url 을 통해서 비대면 면접을 진행해주세요. <br />
        </p>

        <v-row>
            <v-col cols="auto">
                <span class="d-inline-block font-weight-bold mt-12" v-if="mode == 'view'"> 참여코드 입력 후 면접 참여 </span>
                <v-text-field
                    v-model="code"
                    ref="code-input"
                    v-bind="{
                        ...attrs_input,
                        errorMessages,
                        hideDetails: 'auto',
                        placeholder: '참여코드',
                        clearable: true,
                        class: { 'mt-12': mode == 'view' },
                        style: {
                            maxWidth: '320px',
                        },
                    }"
                    @input="onCodeInput"
                    @keydown.enter="enter"
                >
                    <template #append-outer>
                        <v-btn color="primary" class="mt-n8" v-bind="{ disabled, loading }" @click="enter"> 참여하기 </v-btn>
                    </template>
                </v-text-field>
            </v-col>
            <template v-if="$scopedSlots['create']">
                <v-col cols="auto">
                    <span class="d-inline-block font-weight-bold mt-12" v-if="mode == 'view'"> 면접 생성하기 </span>
                    <slot name="create" v-bind="{ loading }" />
                </v-col>
            </template>
        </v-row>
    </interview-action-enter>
</template>

<script>
import { attrs_input } from "@/assets/variables";
import interviewActionEnter from "../action/interview-action-enter.vue";

export default {
    components: { interviewActionEnter },
    props: {
        mode: { type: String, default: null },
    },
    data: () => ({
        code: null,
        attrs_input,
    }),
    computed: {
        disabled() {
            return (this.code?.length || 0) < 8;
        },
    },
    methods: {
        onCodeInput() {
            this.code = this.code?.toUpperCase?.();
        },
        onError() {
            this.$refs["code-input"].focus();
        },
    },
};
</script>

<style>
</style>